import React from 'react'
import { callSetFriendshipStatus } from '../../../sportnections/helpers'
import FriendshipStatus from '../../../sportnections/friendship-status'
import Loader from '../../../shared/loader'
import FriendshipButton from './friendship-button'

export const setFriendshipStatus = (_that, newStatus, confirmMessage = null) => {
    _that.setFriendshipLoader(null, true)

    const caller = callSetFriendshipStatus(_that.state.user, newStatus, confirmMessage)

    if (!caller) {
        return null
    }

    return caller.then(() => {
        window.location.reload()
    })
}

export const renderFriendshipButtons = (_that, squareLook) => {
    const friendshipState = _that?.state?.friendshipState
    const friendshipType = _that?.state?.friendshipType

    if (_that?.state?.friendshipLoader) {
        return <Loader />
    }

    if (_that?.state?.user?.id === _that?.props?.authedUser?.id) {
        return null
    }

    if (!(parseInt(friendshipState, 10) === 1 && friendshipType === 'in')) {
        return (
            <FriendshipStatus
                user={_that.state.user}
                loader={{
                    setLoader: _that.setFriendshipLoader,
                    loader: 'friendshipLoader',
                }}
                successReload={true}
                squareLook={squareLook}
            />
        )
    }

    return (
        <FriendshipButton
            upperState={_that}
            squareLook={squareLook}
        />
    )
}
